
import React, { useState, useCallback, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled, { ThemeContext } from 'styled-components'
import Row from '../../../components/Row'
import CollectionCard from './CollectionCard'
import { ButtonYellowLight } from '../../../components/Button'
import { getCollection } from '../../../service/nft'
import { useActiveWeb3React } from '../../../hooks'
import useYam from '../../../hooks/bakery/useYam'
import { MARKETTYPEV3 } from '../../../constants/bakery/nft'
import { userNftAddress } from '../../../userType/userNftAddress'
// import { 
//   getBmoncAddress
//  } from '../../../sushi/utils'

// swiper
import { windowSize } from '../../../utils/func'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const CollectionWapper = styled.div`
  max-width: 1440px;
  margin: auto;
  margin-top: 64px;
  position: relative;
  box-sizing: border-box;
  padding: 0px 25px;
`

const NextRightIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  right: 0px;
  top: 170px;
  cursor: pointer;
`
const PrevLeftIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 170px;
  cursor: pointer;
`


const Title = styled(Row)`
  
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ theme }) => theme.bsText32};
`
const SwiperWrapper = styled(Row)`
  position: relative;
  display: flex;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fill, 272px);
  flex-wrap: nowrap;
  overflow: auto;
  margin-top: 20px;
  max-width: 100%;
  .swiper-pagination {
    display: none;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active {
    background: #fffdfa;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-content: center;
  `}
`
const Button = styled(ButtonYellowLight)`
  width: 326px;
  height: 48px;
  margin: auto;
  margin-top: 45px;
  color: #FF7A00;
  align-items: center;
  display: flex;
  img{
    width: 24px;
    height: 24px;
    margin-right: 3px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 80%;
  `}
`

export default function TrendingCollections() {
  const sushi = useYam()
  const { chainId } = useActiveWeb3React()
  const theme = useContext(ThemeContext)
  const history = useHistory();

  interface props {
    image: string,
    avatar: string,
    title: string,
    total?: string,
    marketType: string,
    disPlayMarkets: Array<string>,
    urlName: string
  }

  let collectionsData:Array<props>= [
    {
      image: '/images/trending/binamon.png',
      avatar: '/images/trending/binamon_avatar.png',
      title: 'Binamon',
      marketType: MARKETTYPEV3.BINAMONV3,
      disPlayMarkets: [MARKETTYPEV3.BINAMONV3],
      urlName: '/collection/Binamon'
    },
    {
      image: '/images/trending/toy.png',
      avatar: '/images/trending/toy_avatar.png',
      title: 'Alchemy Toys',
      marketType: MARKETTYPEV3.TOYV3,
      disPlayMarkets: [MARKETTYPEV3.TOYV3, MARKETTYPEV3.GAV3],
      urlName: '/collection/toy'
    },
    {
      image: '/images/trending/bark.png',
      avatar: '/images/trending/bark_avatar.png',
      title: 'Barking Sounds',
      marketType: MARKETTYPEV3.BARKNFTV3,
      disPlayMarkets: [MARKETTYPEV3.BARKNFTV3],
      urlName: '/collection/bark'
    },
    {
      image: '/images/trending/doggy.png',
      avatar: '/images/trending/doggy_avatar.png',
      title: 'Crypto Doggies',
      marketType: MARKETTYPEV3.DOGGYNFTV3,
      disPlayMarkets: [MARKETTYPEV3.DOGGYNFTV3],
      urlName: '/collection/doggies'
    }
  ]

  const [totalSupply, setTotalSupply] = useState({})
  const [collectionsDatas, setCollectionsDatas] = useState(collectionsData)

  const getCollectionTotal = () => {
    let allMarketTotal = {}
    for(let i = 0; i < collectionsData.length;i++){
      const marketType = collectionsData[i].marketType
      const disPlayMarkets = collectionsData[i].disPlayMarkets
      const nftAddress = disPlayMarkets.map(d => {
        return userNftAddress(sushi, d)
      }).join(",")
      let singleTotal = new Promise((resolve, reject) => {
        getCollection(chainId as number, {
          address: nftAddress
        }, (err: any, data: any) => {
          if (err || data.code !== 0) {
            reject()
            return
          }
          const result = data.data
          let totalSupply:number = 0
          result.forEach((d:any) => {
            totalSupply += d.totalSupply * 1
          })
          resolve(totalSupply)
        })
      })
      allMarketTotal[marketType]=singleTotal
    }
    setTotalSupply(allMarketTotal)
  }
  
  const getCollectionInfo = useCallback(async() => {
    if(!totalSupply){
      return
    }
    for(let i = 0; i < collectionsData.length; i++){
      const marketType = collectionsData[i].marketType
      const total = await totalSupply[marketType]
      collectionsData[i].total = total
    }
    setCollectionsDatas(collectionsData)
  },[collectionsData])

  useEffect(() => {
    getCollectionTotal()
  }, [chainId])

  useEffect(() => {
    getCollectionInfo()
  }, [totalSupply])

  // swiper
  const upToSmall = 500
  const upToMedium = 960
  const upMoreMedium = 1300
  const upToExtraLarge = 1440
  const upToLessLarge = 1520
  const upToMoreLarge = 1600
  const upToLarge = 1750
  const emptySwiper: any = null
  const [swiper, setSwiper] = useState(emptySwiper)
  const [width, setWidth] = useState(windowSize().w)
  const params = {
    loop: true,
    slidesPerView: 4.2,
    spaceBetween: 16,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    onSwiper: setSwiper
  }
  useEffect(() => {
    if (swiper) {
      if(width <= upToSmall){
        swiper.params.slidesPerView = 1
        swiper.params.spaceBetween = 0
      }else if(width <= upToMedium){
        swiper.params.slidesPerView = 1.8
        swiper.params.spaceBetween = 16
      }else if(width <= upMoreMedium){
        swiper.params.slidesPerView = 2.4
        swiper.params.spaceBetween = 16
      }else if(width <= upToExtraLarge){
        swiper.params.slidesPerView = 3
        swiper.params.spaceBetween = 16
      }else if(width <= upToLessLarge){
        swiper.params.slidesPerView = 3.4
        swiper.params.spaceBetween = 16
      }else if(width <= upToMoreLarge){
        swiper.params.slidesPerView = 3.6
        swiper.params.spaceBetween = 16
      }else if(width <= upToLarge){
        swiper.params.slidesPerView = 3.9
        swiper.params.spaceBetween = 16
      }else{
        swiper.params.slidesPerView = 4.2
        swiper.params.spaceBetween = 16
      }
      swiper.autoplay.stop()
    }
  }, [width, swiper])

  const handleResize = useCallback(() => {
    const size = windowSize()
    setWidth(size.w)
  }, [width])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  const slideNext = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const slidePrev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])


  const goCollection = () => {
    history.push(`/explore`)
  }

  return (
    <CollectionWapper>
      <Title>
        Trending Collections
      </Title>
      <SwiperWrapper>
        <Swiper {...params}>
          {
            collectionsDatas.map((d:any, index: any) => {
              return (
                <SwiperSlide key={index}>
                  <CollectionCard key={index} collection={d}></CollectionCard>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </SwiperWrapper>
      <NextRightIcon src={theme.darkMode ? "/images/icon/next-dark.png" : "/images/icon/next.png"} onClick={slideNext}/>
      <PrevLeftIcon src={theme.darkMode ? "/images/icon/prev-dark.png" : "/images/icon/prev.png"} onClick={slidePrev}/>
      <Button onClick={() => goCollection()}><img src="/images/trending/explore.png"/>Explore the Marketplace</Button>
    </CollectionWapper>
  )
}

